module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLTProBlkCn.3396cc0b.otf";